import { GetStaticPaths } from 'next'
import { coreActions } from '@ucheba/store/core'
import InstitutionPage from './index/index'
import { wrapper } from '../../../../store/store'
import { revalidate } from '../../constants'
import { getIndexPageServerProps } from '../../bll/getIndexPageServerProps'

export const getStaticPaths: GetStaticPaths = async () => {
  return {
    paths: [],
    fallback: 'blocking',
  }
}

export const getStaticProps = wrapper.getStaticProps(
  (store) =>
    async (ctx): Promise<any> => {
      const { dispatch } = store
      const { notFound, content } = await getIndexPageServerProps({ ctx, store })

      if (notFound) {
        return {
          notFound: true,
          revalidate,
        }
      }

      dispatch(coreActions.toggleTouch(false))

      return {
        props: {
          content,
        },
        revalidate,
      }
    }
)

export default InstitutionPage
